export default "__VITE_ASSET__BBsk3_oG__"